import { AnalyticsUserEvent, MoneyMapStatus } from '@fruitful/types';
import { Link, router } from 'expo-router';
import * as React from 'react';
import {
    ArrowRightIcon,
    BodyLargeEmphasized,
    BodyMediumRegular,
    Icon,
    Image,
    View,
    YStack,
} from 'smoothie';

import boxOfOrangesImage from '../../../assets/images/illustrations/box-of-oranges.png';
import { useAuthedUser } from '../../common/providers/AuthedUserProvider';
import { SIDEBAR_CONTENT_MAX_WIDTH } from '../../common/utils/homeUtils';
import { isPreMoneyMapUser } from '../../common/utils/userUtils';
import { track } from '../../logger/Logger';
import { useGetMoneyMapForMembership } from '../../roadmap/hooks/useGetMoneyMapsForMembership';

interface ReferralsCtaCardProps {
    showPreMoneyMap?: boolean;
}

export const ReferralsCtaCard = ({
    showPreMoneyMap = false,
}: ReferralsCtaCardProps) => {
    const handlePress = () => {
        track(AnalyticsUserEvent.REFERRALS_CTA_PRESSED);
        router.navigate('/referrals');
    };

    const { data: moneyMap, isLoading: isMoneyMapLoading } =
        useGetMoneyMapForMembership();

    const user = useAuthedUser();

    const isLegacyUser = isPreMoneyMapUser(user);

    if (isMoneyMapLoading) {
        return null;
    }

    const hasReceivedMoneyMap =
        moneyMap?.status !== undefined &&
        [MoneyMapStatus.ACTIVE, MoneyMapStatus.PREVIEW].includes(
            moneyMap?.status,
        );

    if (!showPreMoneyMap && !isLegacyUser && !hasReceivedMoneyMap) {
        return null;
    }

    return (
        <View
            backgroundColor="$green500"
            height={188}
            borderRadius={16}
            padding={16}
            position="relative"
            overflow="hidden"
            width="100%"
            maxWidth={SIDEBAR_CONTENT_MAX_WIDTH}
            onPress={handlePress}
            cursor="pointer"
        >
            <View position="absolute" right={0} bottom={-16}>
                <Image
                    source={boxOfOrangesImage}
                    objectFit="contain"
                    resizeMode="contain"
                    style={{ width: 155.53, height: 162.66 }}
                />
            </View>
            <YStack>
                <BodyLargeEmphasized>Give $100, Get $100!</BodyLargeEmphasized>
                <BodyMediumRegular lineHeight={24} paddingRight={115}>
                    Love Fruitful? Tell your friends. Earn up to $500 if you
                    refer five.{' '}
                    <Link
                        href="https://fruitful.com/legal/referral"
                        target="_blank"
                        asChild
                    >
                        <BodyMediumRegular textDecorationLine="underline">
                            See terms.
                        </BodyMediumRegular>
                    </Link>
                </BodyMediumRegular>
            </YStack>
            <View
                position="absolute"
                bottom={16}
                left={16}
                width={32}
                height={32}
                borderRadius={100}
                backgroundColor="$black"
                alignItems="center"
                justifyContent="center"
            >
                <Icon icon={ArrowRightIcon} size={12} color="$green500" />
            </View>
        </View>
    );
};
